module.exports = __webpack_public_path__ + "img/sprint.56615df0.png";